/*
 * Copyright (c) 2025-2026.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App.jsx';
import onLoad from "./onLoade.js";

onLoad().then()

const root = createRoot(document.getElementById('root'));
root.render(<App/>);
